import * as React from 'react'
import { parseArtifactUrl } from './artifact-url'
import { ArtifactLink } from './nested/artifact-link'

export interface ArtifactPreviewProps {
  url: string
  children: React.ReactNode
}

export function ArtifactPreview({ url, children }: ArtifactPreviewProps) {
  const parsed = parseArtifactUrl(url)

  if (!parsed) {
    // Fallback to regular link for non-artifact URLs
    return (
      <a href={url} className="text-light/80 hover:text-light">
        {children}
      </a>
    )
  }

  return (
    <ArtifactLink url={url} artifactType={parsed.type} artifactId={parsed.id}>
      {children}
    </ArtifactLink>
  )
}
